import { Component, OnInit } from '@angular/core';
import { ClientSideNavService } from '../client-side-nav/services/client-side-nav.service';
import { ClientMainBarService} from './client-main-bar.service';
import { ApplymentModel } from 'src/app/core/services/client-general-settings/applyment/applyment.model';
import { environment } from '@env';
import { Router, ActivatedRoute } from '@angular/router';
import { RegistrationPortalModel } from '@modules/client/registration-portal/service/registration-portal.model';
import { NotificationService } from '@shared/components/notification/notification.service';
import { FormLoginService } from '@shared/components/login/form-login/form-login.service';
// tslint:disable: deprecation
@Component({
  selector: 'app-client-main-bar',
  templateUrl: './client-main-bar.component.html',
  styleUrls: ['./client-main-bar.component.scss']
})
export class ClientMainBarComponent implements OnInit {

  public hideHeader = false;
  public userData: any = {};

  public customSettings: any = {};
  public env = environment;
  public personName = null;
  public applymentInformation;

  constructor(
    public clientSideNavService: ClientSideNavService,
    public clientMainBarService: ClientMainBarService,
    private formLoginService: FormLoginService,
    public applymentModel: ApplymentModel,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private registrationPortalModel: RegistrationPortalModel,
    private notificationService: NotificationService
  ) {
    this.clientMainBarService.getHeaderHideState().subscribe(value => {
      this.hideHeader = value;
    });
  }

  ngOnInit(): void {
    this.applymentInformation = this.registrationPortalModel.getPortalData().applyment_information;
    this.customSettings = this.applymentModel.getSettings();
  }

  isPortalInscrito() {
    return   this.router.url.includes('portal-inscrito');
  }



  openCloseMenu() {
    this.clientSideNavService.toggle();
  }

  openLoginDialog() {
    this.formLoginService.openLoginDialog(this.buildUriParams(this.activatedRoute.snapshot.params));
  }

  goToNewApplyment() {
    this.router.navigate([this.applymentModel.getSettings().domainParams], {queryParamsHandling: 'preserve'});
  }

  goToPortalInscrito() {
    this.router.navigate([this.applymentModel.getSettings().domainParams, 'portal-inscrito'], {queryParamsHandling: 'preserve'});
  }

  goToUserDetails() {
    if (this.customSettings.selective_process_id === null) {
      this.notificationService.notificationOpen(
        'Atualize a página e tente novamente.',
        'ok',
        'alert',
        10000,
        'Processo não encontrado'
      );
    } else {
      this.router.navigate(
        [`${this.applymentModel.getSettings().domainParams}/processo/${this.customSettings.selective_process_id}/pagina/${this.customSettings.user_details_page_id}`],
        {queryParamsHandling: 'preserve'}
      );
    }
  }

  leaveProcess() {
    this.applymentModel.setLogged(this.clientMainBarService.clearSession(true));
  }

  buildUriParams(params) {
    let response = '';
    response += params.uri ? '/' + params.uri : '';
    response += params.uri1 ? '/' + params.uri1 : '';
    response += params.uri2 ? '/' + params.uri2 : '';
    response += params.uri3 ? '/' + params.uri3 : '';
    return response.indexOf('/') === 0 ? response.slice(1) : response;
  }

}
